document.getElementById('cs-form-1150').addEventListener('submit', function(event) {
    event.preventDefault(); // Previene el envío normal del formulario

    var formData = new FormData(this);

    fetch('https://docs.google.com/forms/d/e/1FAIpQLSfiJvNbyZLPhkMJL_Bby6vgNUbGKuG6Xf-OgNFes6e_UR4V5g/formResponse', {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
    })
    .then(() => {
        this.reset(); // Limpia el formulario
        document.getElementById('confirmationModal').style.display = 'block'; // Muestra el modal
    })
    .catch(error => {
        console.error('Error:', error);
    });

    // Lógica para cerrar el modal
    document.querySelector('.close-button').addEventListener('click', function() {
        document.getElementById('confirmationModal').style.display = 'none';
    });
});

